module.exports = __webpack_public_path__ + "static/img/10.3537db8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/10.jpg
// module id = UI8p
// module chunks = 0